<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-sm-6">
                <div class="footer-widget">
                    <div class="footer-logo">
                        <img src="assets/img/logo.svg" alt="logo" />
                    </div>
                    <p>
                        هدفنا أن نجعل حياتك وحياة عائلتك وحياة أطفالك في مأمن من
                        خطر الاختطاف
                    </p>
                    <!-- <div class="footer-link">
                        <a routerLink="/">
                            <img src="assets/img/google-play.png" alt="google image">
                        </a>
                        <a routerLink="/">
                            <img src="assets/img/app-store.png" alt="google image">
                        </a>
                    </div> -->
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="footer-widget pl-90">
                    <h3>الشركة</h3>
                    <ul>
                        <li>
                            <a href="#">
                                أعلانات
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                الدعم
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                التسويق
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                إتصال بنا
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="footer-widget pl-90">
                    <h3>روابط سريعة</h3>
                    <ul>
                        <li>
                            <span (click)="onClick('home')">
                                الرئيسية
                                <i class="flaticon-left"></i>
                            </span>
                        </li>
                        <li>
                            <span (click)="onClick('home')">
                                خدماتنا
                                <i class="flaticon-left"></i>
                            </span>
                        </li>
                        <li>
                            <span (click)="onClick('home')">
                                شاشات التطبيق
                                <i class="flaticon-left"></i>
                            </span>
                        </li>
                        <li>
                            <span (click)="onClick('home')">
                                اراء عملائنا
                                <i class="flaticon-left"></i>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6">
                <div class="footer-widget pl-90">
                    <h3>صفحاتنا</h3>
                    <ul>
                        <li>
                            <a href="#" target="_blank">
                                فيس بوك
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#" target="_blank">
                                تويتر
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#" target="_blank">
                                لينكد إن
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                        <li>
                            <a href="#" target="_blank">
                                إنستجرام
                                <i class="flaticon-left"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 lh-1">
                    <p class="text-center">
                        حقوق النشر © 2022 ل Trackid. كل الحقوق محفوظة.
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>
